




























































import Vue from 'vue'
import Requirements from '@/components/settings/configuration/Requirements.vue'
import ConfigurationForm111 from '@/components/settings/configuration/ConfigurationForm111.vue'
import ConfigurationForm112 from '@/components/settings/configuration/ConfigurationForm112.vue'
import ConfigurationForm113 from '@/components/settings/configuration/ConfigurationForm113.vue'
import ConfigurationForm114 from '@/components/settings/configuration/ConfigurationForm114.vue'
import ConfigurationForm115 from '@/components/settings/configuration/ConfigurationForm115.vue'
import ConfigurationForm116 from '@/components/settings/configuration/ConfigurationForm116.vue'
import ConfigurationForm117 from '@/components/settings/configuration/ConfigurationForm117.vue'
import ConfigurationForm118 from '@/components/settings/configuration/ConfigurationForm118.vue'
import ConfigurationForm119 from '@/components/settings/configuration/ConfigurationForm119.vue'
import ConfigurationForm1110 from '@/components/settings/configuration/ConfigurationForm1110.vue'
import ConfigurationForm121 from '@/components/settings/configuration/ConfigurationForm121.vue'
import ConfigurationForm123 from '@/components/settings/configuration/ConfigurationForm123.vue'
import ConfigurationForm124 from '@/components/settings/configuration/ConfigurationForm124.vue'
import ConfigurationForm125 from '@/components/settings/configuration/ConfigurationForm125.vue'
import ConfigurationForm141 from '@/components/settings/configuration/ConfigurationForm141.vue'
import ConfigurationForm142 from '@/components/settings/configuration/ConfigurationForm142.vue'
import ConfigurationForm143 from '@/components/settings/configuration/ConfigurationForm143.vue'
import ConfigurationForm144 from '@/components/settings/configuration/ConfigurationForm144.vue'
import ConfigurationForm145 from '@/components/settings/configuration/ConfigurationForm145.vue'
import ConfigurationForm151 from '@/components/settings/configuration/ConfigurationForm151.vue'
import ConfigurationForm161 from '@/components/settings/configuration/ConfigurationForm161.vue'
import ConfigurationForm162 from '@/components/settings/configuration/ConfigurationForm162.vue'
import ConfigurationForm171 from '@/components/settings/configuration/ConfigurationForm171.vue'
import ConfigurationForm172 from '@/components/settings/configuration/ConfigurationForm172.vue'
import ConfigurationForm173 from '@/components/settings/configuration/ConfigurationForm173.vue'
import ConfigurationForm131 from '@/components/settings/configuration/ConfigurationForm131.vue'
import ConfigurationForm122 from '@/components/settings/configuration/ConfigurationForm122.vue'
import CodeLists from '@/components/settings/configuration/CodeLists.vue'
import { FETCH_CONFIGURATION } from '@/store/action-types'
import { TranslateResult } from 'vue-i18n'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { SnackbarStateEnum } from '@/types/enums'
import SettingsLanguages from '@/components/settings/configuration/SettingsLanguages.vue'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  activeTab: number
  tabList: any []
  tabsDataList: any []
  codeListData: any | null
}

export default Vue.extend({
  name: 'ConfigurationPage',

  components: {
    ProgressCircular,
    ConfigurationForm111,
    ConfigurationForm112,
    ConfigurationForm113,
    ConfigurationForm114,
    ConfigurationForm115,
    ConfigurationForm116,
    ConfigurationForm117,
    ConfigurationForm118,
    ConfigurationForm119,
    ConfigurationForm1110,
    ConfigurationForm121,
    ConfigurationForm122,
    ConfigurationForm123,
    ConfigurationForm124,
    ConfigurationForm125,
    ConfigurationForm131,
    ConfigurationForm141,
    ConfigurationForm142,
    ConfigurationForm143,
    ConfigurationForm144,
    ConfigurationForm145,
    ConfigurationForm151,
    ConfigurationForm161,
    ConfigurationForm162,
    ConfigurationForm171,
    ConfigurationForm172,
    ConfigurationForm173,
    CodeLists,
    Requirements,
    SettingsLanguages
  },

  props: {
    groupId: Number,
    subGroupId: Number
  },

  data (): ComponentData {
    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      activeTab: 0,
      tabList: [],
      tabsDataList: [],
      codeListData: null
    }
  },

  watch: {
    groupId (newVal): void {
      if(newVal) {
        this.activeTab = 0
        if(newVal === 2) {
          this.fetchCodeList(false)
        }
      }
    },

    subGroupId (newVal): void {
      if(newVal) {
        this.activeTab = 0
        this.fetchData()
      }
    },
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    getTabItems (): any[] {
      if(this.groupId === 1 && this.subGroupId === 1) {
        return this.tabList
        /*return [
          {id: 1, label: 'Adressarten'},
          {id: 2, label: 'Adressgruppen'},
          {id: 3, label: 'Anreden'},
          {id: 4, label: 'Länder'},
          {id: 5, label: 'Notizarten'},
          {id: 6, label: 'Postleitzahlen'},
          {id: 7, label: 'Telefonarten'},
          {id: 8, label: 'Titel'},
          {id: 9, label: 'Verantwortungsarten'},
          {id: 10, label: 'Verknüpfungsarten'}
        ]*/
      } else if(this.groupId === 1 && this.subGroupId === 2) {
        return this.tabList
        /*return [
          {id: 1, label: 'Kontoplan'},
          {id: 2, label: 'Kurse'},
          {id: 3, label: 'Rabatte'},
          {id: 4, label: 'Steuersätze'},
          {id: 5, label: 'Währungen'}
        ]*/
      } else if(this.groupId === 1 && this.subGroupId === 3) {
        return [
          {id: 1, label: 'Arbeiten'}
        ]
      } else if(this.groupId === 1 && this.subGroupId === 4) {
        return this.tabList
        /*return [
          {id: 1, label: 'Dispositionsarten'},
          {id: 2, label: 'Einheiten'},
          {id: 3, label: 'Preisarten'},
          {id: 4, label: 'Produktgruppen'},
          {id: 5, label: 'Textarten'}
        ]*/
      } else if(this.groupId === 1 && this.subGroupId === 5) {
        return this.tabList
        /*return [
          {id: 1, label: 'Konditionen'}
        ]*/
      } else if(this.groupId === 1 && this.subGroupId === 6) {
        return this.tabList
        /*return [
          {id: 1, label: 'Kriterien'},
          {id: 2, label: 'Noten'}
        ]*/
      } else if(this.groupId === 1 && this.subGroupId === 7) {
        return [
          {id: 1, label: 'Gruppen'},
          {id: 2, label: 'Zusatzfelder'},
          {id: 3, label: 'Auswahllisten'}
        ]
      } else {
        return []
      }
    }
  },

  methods: {
    updateCodeList (): void {
      this.fetchCodeList(true)
    },

    fetchData (): void {
      let payload: string = ''
      if(this.groupId === 1) {
        if(this.subGroupId === 1) {
          payload = 'AllgStammdatenAdressenLists'
          this.fetchConfigurationData(payload)
        } else if(this.subGroupId === 2) {
          payload = 'AllgStammdatenFIBULists'
          this.fetchConfigurationData(payload)
        } else if(this.subGroupId === 4) {
          payload = 'AllgStammdatenProdukteLists'
          this.fetchConfigurationData(payload)
        } else if(this.subGroupId === 5) {
          payload = 'AllgStammdatenProjekteLists'
          this.fetchConfigurationData(payload)
        } else if(this.subGroupId === 6) {
          payload = 'AllgStammdatenQMLists'
          this.fetchConfigurationData(payload)
        } else if(this.subGroupId === 7) {
          payload = 'AllgStammdatenFeldtypenLists'
          this.fetchConfigurationData(payload)
        }
      }
    },

    async fetchConfigurationData (payload: string): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_CONFIGURATION, payload)
        this.loading = false
        if(!response.IsError && response.Data) {

          if(this.groupId === 1 && this.subGroupId === 1) {
            let list: any[] = response.Data.ds01
            list.splice(2, 1)
            list.splice(3, 1)
            list.splice(6, 1)
            list.splice(9, 1)
            this.tabList = list.map((item: any, index: number) => {
              return { id: index + 1, label: item.Name }
            })
          } else if(this.groupId === 1 && this.subGroupId === 2) {
            let list: any[] = response.Data.ds01
            list.splice(1, 1)
            this.tabList = list.map((item: any, index: number) => {
              return { id: index + 1, label: item.Name }
            })
          } else {
            this.tabList = response.Data.ds01.map((item: any, index: number) => {
              return { id: index + 1, label: item.Name }
            })
          }

          this.tabsDataList = response.Data
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchCodeList (updateMenuData: boolean): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_CONFIGURATION, 'AllgStammdatenCodelistenLists')
        this.loading = false
        if(!response.IsError && response.Data) {
          this.codeListData = response.Data

          if(updateMenuData) {
            /*if(this.$store.state.sidebar && this.$store.state.sidebar.children) {
              const foundItem: SidebarItem | undefined = this.$store.state.sidebar.children.find((item: SidebarItem) => item.id === 'esoft2')
              if(foundItem && foundItem.children) {
                const foundItem2: SidebarItem | undefined = foundItem.children.find((item2: SidebarItem) => item2.id === 'esoft2.1')
                if(foundItem2 && foundItem2.children) {
                  const foundItem3: SidebarItem | undefined = foundItem2.children.find((item3: SidebarItem) => item3.id === this.selectedTreeFilterItem.pid.toString())
                  if(foundItem3 && foundItem3.children) {
                    const foundItem4: SidebarItem | undefined = foundItem3.children.find((item4: SidebarItem) => item4.id === this.selectedTreeFilterItem.oid.toString())
                    if(foundItem4 && foundItem4.children) {
                      foundItem4.children.push(newEmployee)
                      foundItem4.children = _.orderBy(foundItem4.children, 'text')
                    }
                  }
                }
              }
            }*/
          }

        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

  },

  mounted () {
    this.fetchData()
    if(this.groupId === 2) {
      this.fetchCodeList(false)
    }
  }
})
